import request from '@/api/request'



//PC工作台-设置打卡列表
export function clockSetList(data) {
    return request({
        url: '/api/director/clockSet/lists',
        method: 'GET',
        params: data
    })
}



//PC工作台-设置打卡详情
export function clockSetInfo(data) {
    return request({
        url: '/api/director/clockSet/info',
        method: 'GET',
        params: data
    })
}


//PC工作台-设置打卡修改
export function updateClockSet(data) {
    return request({
        url: '/api/director/clockSet/edit',
        method: 'POST',
        data
    })
}


//PC工作台-ADD设置打卡
export function addClockSet(data) {
    return request({
        url: '/api/director/clockSet/add',
        method: 'POST',
        data
    })
}


//外出打卡设置
export function addClockOut(data) {
    return request({
        url: '/api/director/clockSet/addClockOut',
        method: 'POST',
        data
    })
}

export function updateOutClock(data) {
    return request({
        url: '/api/director/clockSet/updateOutClock',
        method: 'POST',
        data
    })
}


//PC工作台-打卡设置删除
export function clockSetDel(data) {
    return request({
        url: '/api/director/clockSet/del',
        method: 'POST',
        data
    })
}



